import React, { useMemo } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { IReportSettingsFormState } from '../types';
import { FormatValueDropdown } from '../../../../../components/Form';
import { IReactSelectOption } from '../../../../../utils/types';
import { ISchemaFieldsFragment } from '../../../../../utils/apollo/graphqlSchema';

interface IProps {
  settingIndex: number;
  allSchemas: ISchemaFieldsFragment[];
}

const CohortInspectReportSettingSchema = ({
  settingIndex,
  allSchemas,
}: IProps) => {
  const { control, setValue, watch } =
    useFormContext<IReportSettingsFormState>();

  // We have to get all used schemas and filter out available schema options
  // so that user has to specify schema setting only once
  const fieldArrayValues = watch('inspect.schemaInspectSettings');
  const usedSchemas = fieldArrayValues.map(
    (arrayValue) => arrayValue.schemaKey,
  );

  const schemaOptions: IReactSelectOption[] = useMemo(() => {
    return allSchemas.map((schema) => ({
      label: schema.name,
      value: schema.id,
      isDisabled: usedSchemas.includes(schema.id),
    }));
  }, [allSchemas, usedSchemas]);

  const { field, fieldState } = useController({
    name: `inspect.schemaInspectSettings.${settingIndex}.schemaKey`,
    control,
  });
  const { value, onChange } = field;

  const handleChange = (newValue?: string) => {
    onChange(newValue);

    // Reset fields on schema change
    setValue(`inspect.schemaInspectSettings.${settingIndex}.fields`, []);
  };

  return (
    <FormatValueDropdown
      value={value}
      onChange={handleChange}
      options={schemaOptions}
      hasError={Boolean(fieldState.error)}
      placeholder={'Select Schema'}
    />
  );
};

export default CohortInspectReportSettingSchema;
